import { Link2 } from 'lucide-react'
import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/elements/popover'

import { ToolbarButton } from '../toolbar-button'

import { LinkEditBlock } from './link-edit-block'

const LinkEditPopover = ({ editor, size, variant }) => {
  const [open, setOpen] = useState(false)

  const { from, to } = editor.state.selection
  const text = editor.state.doc.textBetween(from, to, ' ')

  const onSetLink = useCallback(
    (url, linkText, openInNewTab) => {
      editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .insertContent({
          type: 'text',
          text: linkText || url,
          marks: [
            {
              type: 'link',
              attrs: {
                href: url,
                target: openInNewTab ? '_blank' : '',
              },
            },
          ],
        })
        .setLink({ href: url })
        .run()

      editor.commands.enter()
    },
    [editor],
  )

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <ToolbarButton
          isActive={editor.isActive('link')}
          tooltip="Link"
          aria-label="Insert link"
          disabled={editor.isActive('codeBlock')}
          size={size}
          variant={variant}
        >
          <Link2 className="size-5" />
        </ToolbarButton>
      </PopoverTrigger>
      <PopoverContent className="w-full min-w-80" align="end" side="bottom">
        <LinkEditBlock onSave={onSetLink} defaultText={text} />
      </PopoverContent>
    </Popover>
  )
}

LinkEditPopover.propTypes = {
  editor: PropTypes.object.isRequired,
  size: PropTypes.string,
  variant: PropTypes.string,
}

export { LinkEditPopover }
